




















































import { Component, Vue } from 'vue-property-decorator';

// Libs
import { EBranch } from '@/lib/build';
import { maintenanceObservable } from '@/lib/maintenance';

// Components
import SplashScreen from '@/components/SplashScreen.vue';
import DialogUpdateAvailable from '@/components/dialogs/DialogUpdateAvailable.vue';

@Component({
  components: {
    DialogUpdateAvailable,
    SplashScreen,
  },
  metaInfo: {
    title: 'Podosmart',
  },
  subscriptions() {
    return {
      maintenance: maintenanceObservable,
    };
  },
})
export default class App extends Vue {
  private incomingAlert: any = null;

  getBannerContent() {
    if (!(this as any).maintenance || !(this as any).maintenance.context.incoming) return;
    return {
      calendar: (this.$moment as any)((this as any).maintenance.context.incoming.start.toISOString())
        .calendar()
        .toLocaleLowerCase(),
      duration: (this.$moment as any)
        .duration((this as any).maintenance.context.incoming.end.diff((this as any).maintenance.context.incoming.start))
        .asMinutes(),
    };
  }

  get layout() {
    /*const t = this.$route.meta.layout || 'default';
    return 'Layout' + t.charAt(0).toUpperCase() + t.slice(1);*/

    const matched = this.$route.matched.filter((route) => route.meta.layout);

    if (!matched.length) {
      return 'LayoutDefault';
    } else {
      const t = matched[0]?.meta.layout || 'default';
      return 'Layout' + t.charAt(0).toUpperCase() + t.slice(1);
    }
  }

  /**
   * Initialize Hotjar tracker
   */
  private static initHotjar() {
    // Settings per environment
    let hotjarSettings = null;
    switch (process.env.VUE_APP_BRANCH) {
      case EBranch.Development:
        hotjarSettings = { hjid: 1581954, hjsv: 6 };
        break;
      case EBranch.Test:
        hotjarSettings = { hjid: 1582021, hjsv: 6 };
        break;
      case EBranch.Beta:
        hotjarSettings = { hjid: 1582023, hjsv: 6 };
        break;
      case EBranch.Production:
        hotjarSettings = { hjid: 1523729, hjsv: 6 };
        break;
      default:
        // Deactivate in local
        return;
    }

    // Inject in window context
    (function (h: any) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = hotjarSettings;
    })(window);

    // Inject in head
    const hotjar = document.createElement('script');
    hotjar.src = `https://static.hotjar.com/c/hotjar-${hotjarSettings.hjid}.js?sv=${hotjarSettings.hjsv}`;
    hotjar.async = true;
    document.head.appendChild(hotjar);
  }

  mounted() {
    App.initHotjar();

    document.addEventListener(
      'incomingAlert',
      (payload: any) => {
        this.incomingAlert = payload.detail;
      },
      false,
    );
  }
}
